import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { endpoints } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Workspace tree + reload — shared by the projects sidebar (in Layout) and the
// Projects page detail/kanban views so they stay in sync. Auto-reloads when
// the user logs in / out so the tree matches session state.
const WorkspaceCtx = createContext(null);
export const useWorkspace = () => useContext(WorkspaceCtx);

export function WorkspaceProvider({ children }) {
  const { user } = useAuth();
  const [tree, setTree] = useState({ folders: [], groups: [], projects: [], tasks: [] });
  const [people, setPeople] = useState([]);
  const [sops, setSops] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const reload = useCallback(async () => {
    try {
      const [t, pp, ss] = await Promise.all([endpoints.tree(), endpoints.people(), endpoints.sops()]);
      setTree(t);
      setPeople(pp);
      setSops(ss);
      setLoaded(true);
    } catch (e) { setLoaded(true); }
  }, []);

  // Refetch whenever authentication state changes (login / logout).
  useEffect(() => {
    if (user && user !== false) reload();
    else {
      setTree({ folders: [], groups: [], projects: [], tasks: [] });
      setPeople([]);
      setSops([]);
    }
  }, [user, reload]);

  return (
    <WorkspaceCtx.Provider value={{ tree, people, sops, loaded, reload }}>
      {children}
    </WorkspaceCtx.Provider>
  );
}
